import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsEye, BsChevronDown, BsChevronUp, BsBuilding, BsPeople, BsInboxFill } from 'react-icons/bs';
import PageHeader from '../../components/PageHeader/PageHeader';
import FilterCard from '../../components/FilterCard/FilterCard';
import Table from '../../components/Table/Table';
import styles from './Birimler.module.css';

const Birimler = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const birimler = [
    {
      id: 1,
      birim: "Uçak Mühendisliği",
      fakulte: "Mühendislik Fakültesi"
    },
    {
      id: 2,
      birim: "Makine Mühendisliği",
      fakulte: "Mühendislik Fakültesi"
    },
    {
      id: 3,
      birim: "Fizik",
      fakulte: "Fen Fakültesi"
    },
    {
      id: 4,
      birim: "Kimya",
      fakulte: "Fen Fakültesi"
    }
  ];

  const handleBirimDetay = (birimId) => {
    const selectedBirim = birimler.find(b => b.id === birimId);
    if (selectedBirim) {
      // navigate(`/birim-detay/${birimId}`);
      navigate(`/birimler/1`);
    }
  };

  const handleAkademisyenlerGit = (birimId) => {
    const selectedBirim = birimler.find(b => b.id === birimId);
    if (selectedBirim) {
      navigate(`/akademisyenler`, {
        state: {
          birimId: selectedBirim.id,
          birimAdi: selectedBirim.birim,
          fakulte: selectedBirim.fakulte
        }
      });
    }
  };

  const filteredBirimler = birimler.filter(birim => 
    birim.birim.toLowerCase().includes(searchTerm.toLowerCase()) ||
    birim.fakulte.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const columns = [
    { key: 'birim', title: 'Birim', sortable: true },
    { key: 'fakulte', title: 'Fakülte', sortable: true },
    {
      key: 'actions',
      title: 'İşlemler',
      render: (_, row) => (
        <div className={styles.actionButtons}>
          <button 
            className={styles.actionButton}
            onClick={() => handleBirimDetay(row.id)}
            title="Birim Detayı"
          >
            <BsBuilding />
          </button>
          <button 
            className={styles.actionButton}
            onClick={() => handleAkademisyenlerGit(row.id)}
            title="Akademisyenler"
          >
            <BsPeople />
          </button>
        </div>
      )
    }
  ];

  const breadcrumbItems = [
    { text: "Ana Sayfa", link: "/" },
    { text: "Birimler", link: "/birimler" }
  ];

  return (
    <div className={styles.wrapper}>
      <PageHeader 
        title="Birimler"
        description="Akademik birimlerin listesi ve detayları"
        breadcrumb={breadcrumbItems}
      />

      <div className={styles.filterSection}>
        <FilterCard>
          <FilterCard.Row>
            <FilterCard.Col>
              <FilterCard.Input
                label="Birim Ara"
                type="text"
                placeholder="Birim adı veya fakülte ile ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </FilterCard.Col>
          </FilterCard.Row>
        </FilterCard>
      </div>

      <div className="card no-inner-shadow">
        <div className="card-body">
          <Table
            data={filteredBirimler}
            columns={columns}
            onSort={handleSort}
            sortConfig={sortConfig}
          />
        </div>
      </div>
    </div>
  );
};

export default Birimler; 